<cipo-dialog-header [title]="dialogTitle()" closeTestId="add-new-attachment-close-button" />
<mat-dialog-content>
    <div class="p-t">
        @switch (dialogData.modalType) {
            @case ("newFile") {
                @if (dialogData.information) {
                    <div
                        fxLayoutGap="4px"
                        fxLayoutAlign="start start"
                        class="cipo-text--bold-sm cipo-text--black-400 m-b-sm">
                        <mat-icon
                            fxFlex="none"
                            class="cipo-icon cipo-icon--sm material-symbols-outlined"
                            aria-hidden="true">
                            info
                        </mat-icon>
                        <span fxLayout="row wrap">
                            {{ "fileExplorer.fileWillBeAdded" | translate }} {{ dialogData.information }}
                        </span>
                    </div>
                }
                <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px" fxLayoutAlign="start stretch">
                    <!-- Left: pick files via a styled button -->
                    <div fxFlex="50" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="12px">
                        <h3 class="m-a-0">{{ "fileExplorer.pleaseSelectFiles" | translate }}</h3>
                        <button
                            mat-raised-button
                            color="primary"
                            class="cipo--width--full"
                            [disabled]="!multiple() && uploader.queue.length > 0"
                            (click)="fileUploader.click()"
                            data-testid="add-new-attachment-select-button">
                            {{ "fileExplorer.selectFiles" | translate }}
                        </button>
                    </div>

                    <!-- Right: drag & drop zone -->
                    <div fxFlex="50">
                        @if (!multiple() && uploader.queue.length > 0) {
                            <div
                                fxLayoutAlign="center center"
                                data-testid="add-new-attachment-drop-zone-disabled"
                                class="cipo-bg--primary-50 my-drop-zone cipo--height--full cipo--width--full cipo--text--center p-a-lg">
                                {{ "fileExplorer.dropFilesHere" | translate }}
                            </div>
                        } @else {
                            <div
                                fxLayoutAlign="center center"
                                ng2FileDrop
                                [class.nv-file-over]="hasBaseDropZoneOver"
                                (fileOver)="fileOver($event)"
                                [uploader]="uploader"
                                role="button"
                                tabindex="0"
                                (click)="fileUploader.click()"
                                (keydown.enter)="fileUploader.click()"
                                (keydown.space)="$event.preventDefault(); fileUploader.click()"
                                [attr.aria-label]="'a11y.fileExplorer.dropZone' | translate"
                                data-testid="add-new-attachment-drop-zone"
                                class="cipo-bg--primary-100 my-drop-zone cipo--height--full cipo--width--full cipo--text--center p-a-lg cipo--cursor--pointer">
                                {{ "fileExplorer.dropFilesHere" | translate }}
                            </div>
                        }
                    </div>
                </div>
                <input
                    [disabled]="!multiple() && uploader.queue.length > 0"
                    type="file"
                    #fileUploader
                    ng2FileSelect
                    [uploader]="uploader"
                    [multiple]="multiple()"
                    [attr.accept]="dialogData.accept || null"
                    data-testid="add-new-attachment-file-input"
                    class="cipo--display--none-important" />
                @if (dialogData.allowCreateVersion && uploader.queue.length) {
                    <mat-checkbox
                        class="m-t cipo--display--block"
                        [checked]="createNewVersion()"
                        [disabled]="uploading()"
                        (change)="toggleCreateVersion($event.checked)"
                        data-testid="add-new-attachment-create-version">
                        {{ "fileExplorer.createNewVersion" | translate }}
                    </mat-checkbox>
                }
                @for (item of uploader.queue; track $index) {
                    <div
                        class="m-t"
                        fxLayout="row"
                        fxLayout.lt-sm="column"
                        fxLayoutGap="16px"
                        fxLayoutAlign="start end">
                        <div class="cipo--min-width--0" fxFlex="50" fxLayout="column" fxLayoutGap="8px">
                            <div
                                class="cipo--min-width--0"
                                fxLayout
                                fxLayoutGap="8px"
                                fxLayoutAlign="space-between center">
                                <div
                                    class="cipo--min-width--0"
                                    fxFlex
                                    fxLayout
                                    fxLayoutGap="16px"
                                    fxLayoutAlign="start center">
                                    @if (item.isError) {
                                        <mat-icon
                                            fxFlex="none"
                                            class="material-icons-outline cipo-text--warn-500"
                                            aria-hidden="true">
                                            error
                                        </mat-icon>
                                    } @else {
                                        <img
                                            fxFlex="none"
                                            [src]="item.file['preview']"
                                            class="cipo--width--50 cipo--height--auto cipo--display--block"
                                            alt="" />
                                    }
                                    <span class="cipo--min-width--0 cipo--text--ellipsed" [title]="item.file.name">
                                        {{ item.file.name }}
                                    </span>
                                </div>
                                <button
                                    fxFlex="none"
                                    mat-icon-button
                                    (click)="removeFile(item)"
                                    color="warn"
                                    [attr.aria-label]="'a11y.common.delete' | translate"
                                    [attr.data-testid]="
                                        'add-new-attachment-delete-button add-new-attachment-delete-file-' + $index
                                    ">
                                    <mat-icon aria-hidden="true">delete</mat-icon>
                                </button>
                            </div>
                            @if (item.isError) {
                                <p class="cipo-text--warn-500 m-a-0">{{ "fileExplorer.uploadError" | translate }}</p>
                            } @else {
                                <mat-progress-bar
                                    [value]="item.progress"
                                    [attr.aria-label]="
                                        'a11y.fileExplorer.uploadProgress' | translate: { name: item.file.name }
                                    " />
                            }
                        </div>
                        <mat-form-field appearance="outline" fxFlex="50" class="cipo--width--full">
                            <mat-label>{{ "fileExplorer.note" | translate }}</mat-label>
                            <textarea
                                matInput
                                cdkTextareaAutosize
                                cdkAutosizeMinRows="2"
                                cdkAutosizeMaxRows="4"
                                maxlength="1000"
                                [disabled]="uploading()"
                                [ngModel]="noteFor(item)"
                                (ngModelChange)="setNote(item, $event)"
                                [placeholder]="'fileExplorer.notePlaceholder' | translate"
                                [attr.data-testid]="'add-new-attachment-note-' + $index"></textarea>
                        </mat-form-field>
                    </div>
                }
            }
            @default {
                <div class="p-t-lg">
                    <mat-form-field appearance="outline" class="cipo--width--full">
                        <mat-label>{{ "fileExplorer.name" | translate }}</mat-label>
                        <input
                            matInput
                            [formControl]="name"
                            maxlength="255"
                            data-testid="add-new-attachment-name-input" />
                        @if (dialogData.mimeType) {
                            <span matTextSuffix>{{ dialogData.mimeType }}</span>
                        }
                        @if (name.hasError("required")) {
                            <mat-error>{{ "errors.required" | translate }}</mat-error>
                        } @else if (name.hasError("maxlength")) {
                            <mat-error>{{ "errors.maxLength" | translate: { maxLength: 255 } }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            }
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close data-testid="add-new-attachment-cancel-button">
        {{ "general.cancel" | translate }}
    </button>
    <button
        mat-raised-button
        color="primary"
        [disabled]="!valid() || uploading()"
        (click)="save()"
        data-testid="add-new-attachment-save-button">
        {{ (dialogData.modalType === "newFile" ? "fileExplorer.upload" : "general.save") | translate }}
    </button>
</mat-dialog-actions>
